import React from 'react';

import { defineMessages, useIntl } from 'react-intl';

import TagIcon from '@atlaskit/icon/core/tag';
import { token } from '@atlaskit/tokens';

const messages = defineMessages({
	iconLabel: {
		id: 'update-work-item-all-fields-action-renderer.ui.action-card.labels-field.icon-label',
		defaultMessage: 'Labels field icon',
		description:
			'Accessible label for the icon representing the labels field in a Jira work item action card.',
	},
});

export function LabelsFieldIcon(): React.JSX.Element {
	const { formatMessage } = useIntl();
	return (
		<TagIcon
			label={formatMessage(messages.iconLabel)}
			size="small"
			color={token('color.icon.subtle')}
		/>
	);
}
